import React, { useEffect, useState } from 'react';
import PublicNavbar from '../../components/PublicNavbar/PublicNavbar';
import { useLocation, useParams, Link, useNavigate } from 'react-router-dom';
import client from '../../api/client';
import { randnumber } from '../../utils/commonHelper';
import showToast from '../../components/CustomToast/toastHelper';
import PublicLayout from '../../layouts/PublicLayout';
import CustomInput from '../../components/CustomInputs/CustomInput';
import { FaArrowRight, FaEye, FaEyeSlash } from 'react-icons/fa';
import CustomButton from '../../components/CustomButton/CustomButton';

const EmailVerified = () => {
    const params = useParams();
    const token = params.token;
    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const isExistingUser = query.get('isExistingUser')?.toLowerCase() === "true";
    const navigate = useNavigate()

    const [inputs, setInputs] = useState({
        token: token,
        password: ''
    });

    const [response, setResponse] = useState<string>('');
    const [showPassword, setShowPassword] = useState<boolean>(false)


    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }
    const handleSubmit = async () => {
        try {
            if (!inputs.password) inputs.password = "He123@" + randnumber(4);
            const apiResponse = await client.post(`/subsidiary/dashboard/users/verify`, inputs);
            const { message } = apiResponse.data;
            setResponse(message);
            showToast(message, "success");
            navigate('/login')
        } catch (err: any) {
            const message = err?.response?.data?.message;
            setResponse(message);
            showToast(message, "error");
        }
    };

    useEffect(() => {
        if (isExistingUser) {
            handleSubmit();
        }
    }, [token]);

    return (
        <PublicLayout>
            <div className='flex items-center justify-center'>


                <div className="w-full md:w-3/5">
                    {response ? (
                        <p className="text-gray-700 mb-6">{response}</p>
                    ) : (
                        !isExistingUser && (
                            <div className="w-full">
                                <CustomInput label='Choose a strong password' name='password' type={showPassword ? 'text' : 'password'} value={inputs.password} onChange={(e: any) => setInputs({ ...inputs, password: e.target.value })} onRightIconClick={() => togglePasswordVisibility()} rightIcon={showPassword ? FaEye : FaEyeSlash} />
                                <CustomButton disabled={inputs.password.length < 8 } text='Accept Invitation' icon={<FaArrowRight/>} onClick={()=> handleSubmit()}/>
                            </div>
                        )
                    )}
                    {isExistingUser && (
                        <Link to="/login">
                            <button
                                className="px-4 py-2 bg-custom-button-green text-black rounded hover:bg-green-900 hover:text-white"
                            >
                                Go to Login
                            </button>
                        </Link>
                    )}
                </div>
            </div>
        </PublicLayout>
    );
};

export default EmailVerified;
